import React, { useState } from "react";
import { timeIcon } from "assets/icons";
import { FaRegTrashCan } from "react-icons/fa6";
import moment from "moment";
import DeleteNotification from "./DeleteNotification";
import { dateFormatWithTime, isEndDateGreater } from "utils/dateFormat";

const ScheduledNotification = ({ notificationList, setNotificationList }) => {
  // set state value
  const [deleteModel, setDeleteModel] = useState(false);
  const [selectedNotificationDetail, setSelectedNotificationDetail] =
    useState("");

  // delete notification handler

  const deleteNotificationHandler = (notificationData) => {
    setSelectedNotificationDetail(notificationData);
    setDeleteModel(true);
  };

  const onClose = () => {
    setDeleteModel(false);
    setSelectedNotificationDetail("");
  };

  return (
    <>
      {
        // Array.isArray(notificationList)
        notificationList?.length > 0 ? (
          notificationList?.map((el) => (
            <div className="notification_content" key={el?._id}>
              <div className="content_left">
                {/* <h4>User Type</h4> */}
                <h5>{el?.title}</h5>
                <p>{el?.description}</p>
              </div>
              <div className="content_right">
                <p>
                  <img src={timeIcon} alt="" />
                  <b>{dateFormatWithTime(el?.scheduleDate)}
                    {/* {dateFormatWithTime(
                      `${el.scheduleDate} ${el.scheduleDate}`
                    )} */}
                  </b>
                </p>
                {/* {isEndDateGreater(
                  new Date(),
                  dateFormatWithTime(`${el.scheduleDate} ${el.scheduleTime}`)
                ) && ( */}
                <button
                  type="button"
                  onClick={() => deleteNotificationHandler(el)}
                >
                  <FaRegTrashCan />
                </button>
                {/* )} */}
              </div>
            </div>
          ))
        ) : (
          <div className="notification_content">
            <h4>No Data Found</h4>
          </div>
        )
      }

      {deleteModel && (
        <DeleteNotification
          selectedNotificationDetail={selectedNotificationDetail}
          onClose={() => onClose()}
          setNotificationList={setNotificationList}
          deleteModel={deleteModel}
        />
      )}
    </>
  );
};

export default ScheduledNotification;
